import "@egaranti/components/dist/build.css";

import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";

import App from "./App.jsx";
import "./i18n";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <Suspense fallback={<div />}>
    <App />
  </Suspense>
);
